module.exports = __webpack_public_path__ + "static/media/vlerat-01.0454d75a.svg";